import React from 'react';
import { useNavigate } from 'react-router-dom';
import './intro.css';
import Button from '../components/button';
import SoundVideo from '../components/sound_video';
import introvid from '../assets/introvid.mp4';

const Intro = () => {
  const navigate = useNavigate();

  return (
    <div className="intro">
      <SoundVideo className="intro_video" src={introvid} autoPlay playsInline onEnded={() => navigate('/home')} />

      <Button className="button2" onclick={() => navigate('/home')} />
    </div>
  );
}

export default Intro;
